import React from "react";

import styles from "./Generator.module.scss";

export const GeneratorButtonsContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.generatorButtonsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
